import { render, staticRenderFns } from "./StitchAssetBrowser.vue?vue&type=template&id=704fccdd&scoped=true"
import script from "./StitchAssetBrowser.vue?vue&type=script&lang=js"
export * from "./StitchAssetBrowser.vue?vue&type=script&lang=js"
import style0 from "./StitchAssetBrowser.vue?vue&type=style&index=0&id=704fccdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fccdd",
  null
  
)

export default component.exports